import richTextInitialHtml from "./rich_text_initial_html"

const THEMES = ["brand", "muted", "success", "warning", "lime", "error"]

export default class CalloutTool {
  static get enableLineBreaks() {
    return true
  }

  static get toolbox() {
    return {
      title: "Callout",
      icon: "<span class=\"icon-[lucide--triangle-alert] size-4\"></span>"
    }
  }

  static get sanitize() {
    return {
      title: false,
      text: {
        br: true,
        div: true
      },
      theme: false
    }
  }

  constructor({ data, readOnly } = {}) {
    this.readOnly = Boolean(readOnly)
    this.data = {
      theme: this.normalizeTheme(data?.theme),
      title: data?.title || "",
      text: data?.text || ""
    }
    this.themeButtons = new Map()
    this.wrapper = null
    this.titleInput = null
    this.textInput = null
  }

  render() {
    this.wrapper = document.createElement("div")
    this.wrapper.className = "editorjs-callout"

    this.titleInput = document.createElement("input")
    this.titleInput.type = "text"
    this.titleInput.placeholder = "Subheading"
    this.titleInput.className = "editorjs-callout__title"
    this.titleInput.value = this.data.title

    this.textInput = document.createElement("div")
    this.textInput.className = "editorjs-callout__text"
    this.textInput.setAttribute("data-placeholder", "Callout text")
    this.textInput.contentEditable = this.readOnly ? "false" : "true"
    this.textInput.innerHTML = richTextInitialHtml(this.data.text)

    this.titleInput.addEventListener("input", () => {
      this.data.title = this.titleInput.value
    })

    this.wrapper.append(this.titleInput, this.textInput)
    this.applyThemeClass()
    return this.wrapper
  }

  renderSettings() {
    const settings = document.createElement("div")
    settings.className = "editorjs-callout-settings"

    THEMES.forEach((theme) => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "editorjs-callout-settings__btn"
      button.textContent = this.themeLabel(theme)
      this.themeButtons.set(theme, button)

      button.addEventListener("click", () => {
        this.data.theme = theme
        this.updateSettingsButtonsState()
        this.applyThemeClass()
      })

      settings.appendChild(button)
    })

    this.updateSettingsButtonsState()
    return settings
  }

  save() {
    return {
      title: this.titleInput?.value || "",
      text: this.textInput?.innerHTML || "",
      theme: this.normalizeTheme(this.data.theme)
    }
  }

  validate(savedData) {
    const title = (savedData?.title || "").trim()
    const tmp = document.createElement("div")
    tmp.innerHTML = savedData?.text || ""
    const text = (tmp.textContent || "").trim()
    return Boolean(title || text)
  }

  applyThemeClass() {
    if (!this.wrapper) return

    THEMES.forEach((theme) => {
      this.wrapper.classList.remove(`editorjs-callout--${theme}`)
    })

    this.wrapper.classList.add(`editorjs-callout--${this.normalizeTheme(this.data.theme)}`)
  }

  updateSettingsButtonsState() {
    this.themeButtons.forEach((button, theme) => {
      button.classList.toggle("editorjs-callout-settings__btn--active", this.data.theme === theme)
    })
  }

  normalizeTheme(theme) {
    return THEMES.includes(theme) ? theme : "brand"
  }

  themeLabel(theme) {
    switch (theme) {
    case "brand":
      return "Brand"
    case "muted":
      return "Muted"
    case "success":
      return "Success"
    case "warning":
      return "Warning"
    case "lime":
      return "Lime"
    case "error":
      return "Error"
    default:
      return "Brand"
    }
  }
}
